<template>
  <div class="difficulty">
    <InformationalIcon
      v-if="difficultyLevel && difficultyLevel === 'informative'"
      :alt="`Icon representing the ${difficultyLevel} difficulty of the content`"
      class="difficulty__informational-img"
    />
    <DifficultyIcon
      v-if="!hideIcon && difficultyLevel && difficultyLevel !== 'informative'"
      :class="[
        'difficulty__levels',
        hideIconOnMobile && 'difficulty__levels--hide',
      ]"
      :color="colored ? color : ''"
      :difficulty="difficultyLevel"
    />
    <div
      v-if="difficultyLevel && difficultyLevel.length"
      class="difficulty__label"
      :class="{
        'difficulty__label--visible': alwaysVisible,
        'difficulty__label--uppercase': uppercase,
        'difficulty__label--bold': bold,
      }"
    >
      {{ difficultyLevel }}
    </div>
    <div v-else class="difficulty__label">N/A</div>
  </div>
</template>

<script>
import DifficultyIcon from '@/components/properties/DifficultyIcon.vue'
import InformationalSvg from '@/assets/icons/difficulty/Informational.svg'

export default {
  name: 'Difficulty',
  components: {
    DifficultyIcon,
    InformationalIcon: { ...InformationalSvg, name: 'InformationalIcon' },
  },
  props: {
    difficultyLevel: {
      type: String,
      required: false,
      default: '',
    },
    colored: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: '#EF7D22', // color prop should go to a constant
    },
    alwaysVisible: {
      type: Boolean,
      required: false,
    },
    hideIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideIconOnMobile: {
      type: Boolean,
      required: false,
      default: false,
    },
    uppercase: {
      type: Boolean,
      required: false,
      default: false,
    },
    bold: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.difficulty {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  align-items: center;
  &__label {
    display: none;
    color: var(--white);
    text-transform: capitalize;
    font-family: var(--font-book);
    @include tablet {
      display: block;
    }
    &--visible {
      display: block;
    }
    &--uppercase {
      text-transform: uppercase;
    }
    &--bold {
      font-family: var(--font-bold);
    }
  }
  &__levels {
    width: 20px;
    margin-right: 10px;

    &--hide {
      display: none;

      @include mobile {
        display: block;
      }
    }
  }
  &__informational {
    &-img {
      width: 25px;
      margin-right: 10px;
    }
  }
}
</style>
